/**
 * Federated Components Registry for Account Microsite
 * Defines which components to load via Module Federation
 */

const { getServerRemoteConfig } = require('../webpack/module-federation-config');
const { yodaCoreComponents } = require('./yodaCoreComponents');
const { yodaSiteComponents } = require('./yodaSiteComponents');

/**
 * Parses server remote configuration and extracts URLs
 * @returns {Object} Parsed remote configuration with URLs
 */
const parseServerRemotes = () => {
    const config = getServerRemoteConfig();
    const parsed = {};

    Object.entries(config).forEach(([key, value]) => {
        parsed[key] = value.split('@')[1] || value;
    });

    return parsed;
};

module.exports.federatedComponents = {
    ...yodaCoreComponents,
    ...yodaSiteComponents,
    __remotes: parseServerRemotes()
};
